<div class="cap-selector-container p-20 align-center">
    <form [formGroup]="form" fxLayout="column" fxFlex>
        <div fxLayout="row" fxLayoutAlign="center center" class="mt-10 ml-10 mr-10">
            <span class="txt-p-16-4">{{ 'cap-modal-pre-pod'|i18n }} <b>{{ pod.pod }}</b> {{ 'cap-modal-post-pod'|i18n }}
                <b>{{ year }}</b>.
            </span>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" class="mb-10 ml-10 mr-10">
            <span class="txt-p-16-4"> {{ 'cap-modal-post-date'|i18n }}</span>
        </div>
        <div app-input-container fxLayout="row" fxFlex fxLayoutAlign="center center" fxLayoutGap="10px"
             class="mt-20 mb-20">
            <span class="txt-p-16-4" fxLayoutAlign="center center">{{ 'Threshold'|i18n }}{{ ':*' }}</span>
            <input app-input
                   type="number"
                   formControlName="cap"
                   min="0"
                   max="100"
                   fxFlex="20"
                   step="0.01"
                   (input)="limitDecimals(form, 'cap')">
            <span class="txt-p-16-4" fxLayoutAlign="center center">
                {{ '% of shared energy from the consumer POD'|i18n }}
            </span>
        </div>
        <div *ngIf="form.hasError('out_of_range_values') && form.controls.cap.touched"
             fxLayout="row" fxLayoutAlign="center center" class="txt-a-16-7 mb-20">
            {{ 'CAP value must be in the range 0-100'|i18n }}
        </div>
    </form>
</div>
